// extracted by mini-css-extract-plugin
export var layout__header = "index-module--layout__header--59466 index-module--wrapper--04345";
export var layout__headerSticky = "index-module--layout__header--sticky--9825d";
export var layout__skipContent = "index-module--layout__skip-content--6335f";
export var layout__wrapper = "index-module--layout__wrapper--8521e index-module--wrapper--04345";
export var wrapper = "index-module--wrapper--04345";